import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { toast } from '@livable/saas-react-components';
import { AddressElement, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { Button } from '@mui/material';
import { sleep } from 'src/utils/sleep';
import { useTranslation } from 'react-i18next';
import { BackdropLoader } from '@livable/saas-react-components';
export const StripeForm = observer(_ref => {
  let methodAdded = _ref.methodAdded,
    handleModalClose = _ref.handleModalClose,
    paymentsCount = _ref.paymentsCount,
    newMethodAdded = _ref.newMethodAdded;
  const store = useStore();
  const stripe = useStripe();
  const classes = useStyles();
  const elements = useElements();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPayProcessing = _useState2[0],
    setIsPayProcessing = _useState2[1];
  const handleSubmit = async event => {
    event.preventDefault();
    setIsPayProcessing(true);
    if (!stripe || !elements) {
      toast('error', {
        body: ['Stripe error']
      });
      setIsPayProcessing(false);
      handleModalClose();
      return;
    }
    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {},
      redirect: 'if_required'
    });
    if (result.error) {
      toast('error', {
        body: [result.error.message]
      });
    } else {
      for (let count = 0; count < 5; count++) {
        const autopayMethodAsync = await store.payment.getAutopayMethodAsync.run();
        const paymentMethodsAsync = await store.payment.getPaymentMethodsHomeDashboardAsync.run({
          applyToHomeDashboard: false
        });
        if (autopayMethodAsync !== null && autopayMethodAsync !== void 0 && autopayMethodAsync.response && paymentMethodsAsync !== null && paymentMethodsAsync !== void 0 && paymentMethodsAsync.response && (paymentMethodsAsync === null || paymentMethodsAsync === void 0 ? void 0 : paymentMethodsAsync.response.length) > paymentsCount) {
          toast('success', {
            body: ['The payment method has successfully added and will be available in a few moments.']
          });
          store.payment.setMethodAdded(true);
          store.payment.setPaymentMethodsAfterLoad(paymentMethodsAsync);
          if (methodAdded) methodAdded();
          if (newMethodAdded) newMethodAdded(true);
          handleModalClose();
          break;
        } else {
          if (count === 4) toast('error', {
            body: ['Stripe error']
          });
        }
        await sleep(3000);
      }
    }
    setIsPayProcessing(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PaymentElement, {
    options: {
      paymentMethodOrder: ['us_bank_account']
    }
  }), /*#__PURE__*/React.createElement(AddressElement, {
    options: {
      mode: 'billing'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '482-pay-gate-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    'custom-attribute': '483-pay-gate-modal'
  }, t('buttons.submit'))))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isPayProcessing || store.payment.getPublicKeyAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress
  }));
});